export default __webpack_public_path__ + "static/media/MuseoModerno-Regular.6019bae4.ttf";